import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AuthContext from '../../contexts/authentication/AuthProvider';
import { useContext } from 'react';

const GuestGuard = () => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  if (auth.isAuthenticated)
    return (
      <Navigate
        to="/"
        state={{ from: location }}
        replace
      />
    );

  return <Outlet />;
};

export default GuestGuard;
